module.exports = __webpack_public_path__ + "media/images/thoughtful-nurse-7ea6ae2a07e39ed4c07d72d3517de008.svg";